export default class Product {
    static get PACKAGE_CODE() {
        return {
            LCP: 'CBS_ALL_ACCESS_LOW_COST_PACKAGE',
            LC: 'CBS_ALL_ACCESS_PACKAGE',
            CF: 'CBS_ALL_ACCESS_AD_FREE_PACKAGE'
        };
    }

    static get TYPE_MONTHLY() {
        return 'monthly';
    }

    static get TYPE_ANNUAL() {
        return 'annual';
    }
}
